import { Column, ColumnEditorOptions } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { IBranchInvoiceConsultantWise } from "./Table";
import { Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";
import { ConsultantWisePaymentUpdate } from "./ConsultantWisePaymentUpdate";
import { Toolbar } from "primereact/toolbar";
import { JVDropdown } from "../../shared/JVDropdown";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { MultiSelect } from "primereact/multiselect";

interface IProps {
  open: boolean;
  singleData: any;
  toast: any;
  type: string;
  diff: number;
  onClose: () => void;
}

interface IData {
  paymentStatus: string;
}

const schema = yup.object({
  paymentStatus: yup.string().required("Status is required"),
});

const Payment_Status = [
  { name: "-- SELECT --", value: null },
  { name: "Pending", value: "Pending" },
  { name: "Paid", value: "Paid" },
];

interface IBranchIncentiveList {
  id?: number;
  branch_Invoice_ID?: number;
  fromDate?: Date;
  toDate?: Date;
  consultant_ID?: number;
  consultant_Name?: string;
  vendor_Company_ID?: number;
  vendor_Company_Name?: string;
  paymentStatus?: string;
  payment_Date?: Date;
  is_Verified?: boolean;
  invoiceHours?: number;
  mRate?: number;
  invoiceAmount?: number;
  deduction?: number;
  branchInvoiceAmount?: number;
  percentage_Share?: number;
  branch_ID?: number;
  branchName?: string;
  company_ID?: number;
  company_Name?: string;
  validHours?: number;
  receivedAmount?: number;
  sales_Branch?: string;
  sales_Comp?: string;
  recruiter_Branch?: string;
  recruiter_Comp?: string;
  branch_Incentive_PaymentStatus?: string;
  forward_Invoice_ID?: string;
  sales?: string;
  recruiter?: string;
  poDate?: Date;
  sRate?: number;
  bRate?: number;
}

const columns: string[] = [
  "Sales Manager",
  "Recruiter",
  "SRate",
  "BRate",
  "PO Date"
];

export const GenerateBranchIncentiveList = (props: IProps) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IBranchIncentiveList[]; loading: boolean });
  const [openUpdatePaymentStatus, setOpenUpdatePaymentStatus] = useState({ open: false, singleData: {} } as { open: boolean; singleData: IBranchIncentiveList });
  const [openUpdatePaymentStatus2, setOpenUpdatePaymentStatus2] = useState({ open: false, singleData: {} } as { open: boolean; singleData: any });
  const [selectedBranchWiseIncentive, setSelectedBranchWiseIncentive] = useState<IBranchIncentiveList[]>([]);
  const [loading, setLoading] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState<string[]>([]);
  const dt = useRef<any>(null);
  const onHide = () => {
    setSelectedBranchWiseIncentive([]);
    setVisibleColumns([]);
    props.onClose();
  };
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm<IData>({
    resolver: yupResolver(schema),
    defaultValues: props.singleData,
    shouldFocusError: false,
  });
  const _roles: Array<number> = [];
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });

  const loadTableData = async () => {
    setTableData({ tableData: tableData.tableData, loading: true });
    const response = await Fetch("InvoiceTracking/getBranchInvoiceConsultantWise", "GET", null, `branchInvoiceID=${props.singleData.id}&status=${props.type}`, props.toast);
    if (response) {
      const data: IBranchIncentiveList[] = await response.json();
      setTableData({
        tableData: data.map((el: IBranchIncentiveList, index: number) => {
          return { ...el, sn: index + 1 };
        }),
        loading: false,
      });
    } else {
      setTableData({ tableData: tableData.tableData, loading: false });
    }
  };

  const updateRow = async (data: any) => {
    let body = {
      id: data.id,
      validHours: data.validHours,
      branch_Invoice_ID: data.branch_Invoice_ID,
    };

    const response = await Fetch("InvoiceTracking/updateGenerateBranchInvoiceConsultantInvoiceByID", "PUT", body, null, props.toast);
    if (response) {
      props.toast.current?.show({ severity: "success", summary: "Success", detail: "Hours Updated Successfully" });
      loadTableData();
    } else {
      props.toast.current?.show({ severity: "error", summary: "Error", detail: "Failed to Updated Hours" });
      loadTableData();
    }
  };

  const isPositiveInteger = (val: any) => {
    let str = String(val);

    str = str.trim();

    if (!str) {
      return false;
    }

    str = str.replace(/^0+/, "") || "0";
    let n = Math.floor(Number(str));

    return n !== Infinity && String(n) === str && n >= 0;
  };

  const onCellEditComplete = async (e: any) => {
    let { rowData, newValue, field, originalEvent: event } = e;

    switch (field) {
      case "quantity":
      case "validHours":
        if (isPositiveInteger(newValue)) rowData[field] = newValue;
        else event.preventDefault();
        break;

      default:
        if (newValue.trim().length > 0) rowData[field] = newValue;
        else event.preventDefault();
        break;
    }

    let updateData: any = rowData;
    updateData.validHours = newValue;
    updateRow({ id: updateData.id, validHours: Number(updateData.validHours || updateData.invoiceHours || "0"), branch_Invoice_ID: props.singleData.id });
    // if (await updateRow(updateData)) {
    //     setTableData(prev => {
    //         const updatedData = prev.tableData.map(item => {
    //             if (item.id === rowData.id) {
    //                 return { ...item, validHours: newValue };
    //             }
    //             return item;
    //         });
    //         return { ...prev, tableData: updatedData };
    //     })
    // };
  };

  const cellEditor = (options: ColumnEditorOptions) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (options.editorCallback) {
        options.editorCallback(e.target.value);
      }
    };

    return <input style={{ width: "100%", margin: 0, padding: "3px 5px", border: "2px solid green", outline: "none", cursor: "pointer" }} value={options.value} type="number" onChange={(e) => handleChange(e)} />;
  };

  const action = (rowData: IBranchIncentiveList) => {
    return props.diff === 0 && props.type === "" && props.singleData.id === rowData.branch_Invoice_ID ? (
      <Button className="pi pi-pencil text-primary bg-white border-none text-base" tooltip="Update Payment" onClick={() => setOpenUpdatePaymentStatus({ open: true, singleData: rowData })}></Button>
    ) : (
      <></>
    );
  };

  const onSubmit = async (data: IData) => {
    setLoading(true);

    const newList: any = selectedBranchWiseIncentive;
    const bodyData: {
      id: number;
      branch_ID: number;
      branch_Invoice_ID: number;
      PaymentStatus: string;
    }[] = newList.map((el: any) => {
      return {
        id: el.id,
        branch_ID: el.branch_ID,
        branch_Invoice_ID: el.branch_Invoice_ID,
        PaymentStatus: data.paymentStatus,
      };
    });

    if (
      props.diff > 0 &&
      Number(
        selectedBranchWiseIncentive
          .map((ele) => ele.branchInvoiceAmount || 0)
          .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
          .toFixed(2),
      ) === props.diff
    ) {
      const response = await Fetch("InvoiceTracking/bulkUpdateGenerateBranchInvoiceConsultantInvoiceByID", "PUT", bodyData, null, props.toast);
      if (response) {
        setLoading(false);
        props.toast.current?.show({ severity: "success", summary: "Success", detail: "Updated Successfully" });
        loadTableData();
        setOpenUpdatePaymentStatus2({ open: false, singleData: {} });
        setSelectedBranchWiseIncentive([]);
        onHide();
      } else {
        setLoading(false);
        props.toast.current?.show({ severity: "error", summary: "Error", detail: "Failed to Updated" });
      }
    } else if (props.diff > 0 && selectedBranchWiseIncentive.map((ele) => ele.branchInvoiceAmount || 0).reduce((accumulator, currentValue) => accumulator + currentValue, 0) !== props.diff) {
      props.toast.current?.show({ severity: "error", summary: "Error", detail: `Sum of selected PV Invoice Amount does not match to entered Recieved Branch Invoice amount $${props.diff}` });
      setLoading(false);
    } else {
      const response = await Fetch("InvoiceTracking/bulkUpdateGenerateBranchInvoiceConsultantInvoiceByID", "PUT", bodyData, null, props.toast);
      if (response) {
        setLoading(false);
        props.toast.current?.show({ severity: "success", summary: "Success", detail: "Updated Successfully" });
        loadTableData();
        setOpenUpdatePaymentStatus2({ open: false, singleData: {} });
        setSelectedBranchWiseIncentive([]);
      } else {
        setLoading(false);
        props.toast.current?.show({ severity: "error", summary: "Error", detail: "Failed to Updated" });
      }
    }
  };

  const updateBranchInvoice = async () => {
    setOpenUpdatePaymentStatus2({ open: true, singleData: {} });
  };

  const exportCSV = () => {
    dt.current.exportCSV();
    setVisibleColumns([]);
  };

  const onColumnToggle = (event: any) => {
    let selectedColumns = event.value;
    let orderedSelectedColumns = columns.filter((col) => selectedColumns.some((sCol: string) => sCol === col));

    setVisibleColumns(orderedSelectedColumns);
  };

  const rightToolbarTemplate = () => {
    return (
      <div className="flex gap-4">
        {selectedBranchWiseIncentive.length > 0 && (props.singleData.payment_Status === null || props.singleData.payment_Status === "Pending" || _roles.includes(1) || _roles.includes(26)) && (
          <Button label="Bulk Update Payment Status" disabled={loading} loading={loading} icon="pi pi-upload" className="p-button" onClick={updateBranchInvoice} />
        )}
        <MultiSelect value={visibleColumns} options={columns} optionLabel="" placeholder="Select Extra Export Columns" onChange={onColumnToggle} className="w-full sm:w-20rem" display="chip" />
        <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} />
      </div>
    );
  };

  const rowClass = (data: any) => {
    return {
      // 'bg-blue-200 text-black': data.forward_Invoice_ID !== null && data.branch_Invoice_ID !== props.singleData.id,
      "bg-blue-200 text-black": data.branch_Invoice_ID !== props.singleData.id,
    };
  };

  const DateFormat = loginObj.date_Format;

  useEffect(() => {
    if (props.open && props.singleData.id) {
      loadTableData();
    }
  }, [props.open]);

  return (
    <>
      <Dialog visible={props.open} style={{ width: "80vw" }} header="Add/Edit Branch Invoice" modal className="p-fluid" onHide={onHide}>
        <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
        <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }} ref={dt}
          size="small" stripedRows scrollHeight="65vh" dataKey="id"
          value={tableData.tableData.map((item) => ({
            ...item,
            salesBranchComp: `${item.sales_Branch} (${item.sales_Comp?.split(" ")[0] || ""})`,
            recruiterBranchComp: `${item.recruiter_Branch} (${item.recruiter_Comp?.split(" ")[0] || ""})`,
          }))}
          emptyMessage="No Incentives found."
          loading={tableData.loading}
          selectionMode={"checkbox"}
          selection={selectedBranchWiseIncentive}
          showGridlines
          responsiveLayout="scroll"
          onSelectionChange={(e) => {
            const value = e.value.filter((ele: IBranchIncentiveList) => props.singleData.id === ele.branch_Invoice_ID) as IBranchIncentiveList[];
            if (props.diff > 0) {
              const sum: number = value.map((ele) => ele.branchInvoiceAmount || 0).reduce((a, c) => a + c, 0);
              if (sum <= props.diff) setSelectedBranchWiseIncentive(value);
            } else setSelectedBranchWiseIncentive(value);
            //setSelectedBranchWiseIncentive(value.filter(fl => fl.forward_Invoice_ID === null || fl.branch_Invoice_ID === props.singleData.id));
          }}
          rowClassName={rowClass}
        >
          {props.diff > 0 && <Column style={{ minWidth: "3rem", maxWidth: "3rem" }} selectionMode="multiple" />}
          <Column
            field="sn"
            header="SN"
            style={{ minWidth: "3rem", maxWidth: "3rem" }}
            footer={() => {
              return <span className="">Total</span>;
            }}
          />
          <Column
            field="branch_Invoice_Date"
            header="Invoice Date"
            body={(rowData: any) => {
              return props.singleData.id !== rowData.branch_Invoice_ID ? (
                <p>
                  {new Date(rowData?.branch_Invoice_Date || "").toLocaleString("default", { month: "short" })} - {new Date(rowData?.branch_Invoice_Date || "").getFullYear()}
                </p>
              ) : (
                <p></p>
              );
            }}
          />
          {/* <Column field="fromDate" header="From Date" body={(rowData: IBranchInvoiceConsultantWise) => {
                        let date;
                        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<p>{date}</p>);
                    }} />
                    <Column field="toDate" header="To Date" body={(rowData: IBranchInvoiceConsultantWise) => {
                        let date;
                        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<p>{date}</p>);
                    }} /> */}
          <Column field="fromDate" header="From Date" style={{ minWidth: "100px" }} body={(rowData: any) => safeFormatDate(rowData.fromDate, "dd/MM/yyyy", DateFormat)} />
          <Column field="toDate" header="To Date" style={{ minWidth: "100px" }} body={(rowData: any) => safeFormatDate(rowData.toDate, "dd/MM/yyyy", DateFormat)} />
          <Column field="branchName" header="Branch" />
          <Column field="company_Name" header="Company " />
          {/* <Column field="sales_Branch" header="Sales Branch (Comp)" body={(rowData) => <p>{rowData.sales_Branch + " (" + rowData.sales_Comp.split(" ")[0] + ")"}</p>} /> */}
          {visibleColumns.includes("Sales Manager") && <Column field="sales" header="Sales Manager" />}
          <Column field="salesBranchComp" header="Sales Branch (Comp)" />
          {/* <Column field="recruiter_Branch" header="Recruiter Branch (Comp)" body={(rowData) => <p>{rowData.recruiter_Branch + " (" + rowData.recruiter_Comp.split(" ")[0] + ")"}</p>} /> */}
          {visibleColumns.includes("Recruiter") && <Column field="recruiter" header="Recruiter" />}
          <Column field="recruiterBranchComp" header="Recruiter Branch (Comp)" />
          {visibleColumns.includes("PO Date") && <Column field="poDate" header="PO Date" body={(rowData: any) => safeFormatDate(rowData.poDate, "dd/MM/yyyy", DateFormat)} />}
          <Column field="consultant_Name" header="Consultant Name" />
          <Column field="vendor_Company_Name" header="Client Company" />
          <Column field="paymentStatus" header="PV Payment Status" />
          {/* <Column field="payment_Date" header="Payment Date" body={(rowData: IBranchInvoiceConsultantWise) => {
                        let date;
                        if (rowData.payment_Date) date = format(new Date(rowData.payment_Date), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<p>{date}</p>);
                    }} /> */}
          <Column field="payment_Date" header="Payment Date" style={{ minWidth: "100px" }} body={(rowData: any) => safeFormatDate(rowData.payment_Date, "dd/MM/yyyy", DateFormat)} />
          {/* <Column field="is_Verified" header="is_Verified" /> */}
          <Column field="invoiceHours" header="Hours" />
          {visibleColumns.includes("SRate") && <Column field="sRate" header="S Rate" />}
          {visibleColumns.includes("BRate") && <Column field="bRate" header="B Rate" />}
          <Column field="mRate" header="Margin" />
          <Column field="invoiceAmount" header="Invoice Amount $" />
          <Column field="deduction" header="Deduction $" />
          <Column field="branchInvoiceAmount" header="Net Amount $" body={(rowData) => <p>{Number(rowData.invoiceAmount || "0") - Number(rowData.deduction || "0")}</p>} />
          <Column field="percentage_Share" header="Share %" />
          <Column
            field="branchInvoiceAmount"
            header="Branch Share $"
            style={{ minWidth: "11rem" }}
            footer={() => {
              const StatusNotChange = tableData.tableData.reduce((sum, item) => sum + (item.branchInvoiceAmount || 0), 0).toFixed(2);
              const StatusNotChange2 = tableData.tableData
                .filter((ele) => ele.branch_Invoice_ID !== props.singleData.id)
                .reduce((sum, item) => sum + (item.branchInvoiceAmount || 0), 0)
                .toFixed(2);
              const StatusNotChange3 = tableData.tableData
                .filter((ele) => ele.branch_Invoice_ID === props.singleData.id)
                .reduce((sum, item) => sum + (item.branchInvoiceAmount || 0), 0)
                .toFixed(2);
              return (
                <div className="flex flex-column gap-3">
                  <span className="flex flex-column">
                    <span style={{ fontWeight: "lighter" }}>Current Inv Amount : </span>
                    <span style={{ fontWeight: "bolder" }}>{StatusNotChange3}</span>
                  </span>
                  <span className="flex flex-column bg-blue-300">
                    <span style={{ fontWeight: "lighter" }}>Prev Inv Pending Amount : </span>
                    <span style={{ fontWeight: "bolder" }}>{StatusNotChange2}</span>
                  </span>
                  <span className="flex flex-column">
                    <span style={{ fontWeight: "lighter" }}>Total : </span>
                    <span style={{ fontWeight: "bolder" }}>{StatusNotChange}</span>
                  </span>
                </div>
              );
            }}
          />
          {/* <Column field="validHours" header="Paid Hours" editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} /> */}
          <Column
            field="receivedAmount"
            header="Received Amount"
            footer={() => {
              const StatusNotChange = tableData.tableData.reduce((sum, item) => sum + (item.receivedAmount || 0), 0);
              return <span className="">{StatusNotChange.toFixed(2)}</span>;
            }}
          />
          <Column field="branch_Incentive_PaymentStatus" header="Payment Status" body={(rowData: any) => <p>{rowData.branch_Incentive_PaymentStatus || "Paid"}</p>} />
          {_roles.includes(1) && (props.singleData.payment_Status === null || props.singleData.payment_Status === "Pending" || _roles.includes(1) || _roles.includes(26)) && <Column field="" header="Action" body={action} />}
        </DataTable>
        <Dialog
          visible={openUpdatePaymentStatus2.open}
          style={{ width: "80vw" }}
          header="Add/Edit Consultant Wise Incentive"
          modal
          className="p-fluid"
          onHide={() => {
            setOpenUpdatePaymentStatus2({ open: false, singleData: {} });
            setSelectedBranchWiseIncentive([]);
            setLoading(false);
          }}
        >
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDropdown
              column={1}
              label="Payment Status"
              control={control}
              name="paymentStatus"
              options={props.diff > 0 && props.type !== "" ? Payment_Status.filter((f) => f.name !== props.type) : Payment_Status}
              optionLabel="name"
              optionValue="name"
              placeholder="Select Payment Status"
              error={errors.paymentStatus?.message}
            />
            <div className="col-12 md:col-12 flex gap-4 justify-content-end">
              <Button style={{ width: "100px" }} disabled={loading} loading={loading} label="SAVE" type="submit"></Button>
              <Button style={{ width: "100px" }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
            </div>
          </form>
        </Dialog>
      </Dialog>
      <ConsultantWisePaymentUpdate open={openUpdatePaymentStatus.open} singleData={openUpdatePaymentStatus.singleData} branchInvoiceID={props.singleData.id} onHide={() => setOpenUpdatePaymentStatus({ open: false, singleData: {} })} loadTableData={() => loadTableData()} toast={props.toast} />
    </>
  );
};
